module.exports = __webpack_public_path__ + "img/topic-cancel.7969a88c.png";